<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(v-on="on" color="primary" text) {{translations.button}}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ translations.title }} {{data.name}}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-container.text-center(fluid)
          v-row.px-0.px-md-10.pb-0.pb-sm-2.pb-md-4
            v-col(v-if="data.items.length == 0" cols="12")
              p {{ translations.empty }}
            v-col(v-else cols="12")
              v-data-table(:headers="headers"
                :items="data.items"
                :items-per-page="30"
                :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}")
                template(v-slot:body="{ items }")
                  tbody
                    tr(v-for="item,ind in items", :key="'item'+ind")
                      td.text-start
                        span.fantasy__block-width--8 {{ item.n }}
                      td.text-start {{ ind + 1 }}
                      td.text-start {{ item.p }}
                      td.text-start
                        v-icon(v-if="item.rollDown == 'true'" color="green lighten-1") mdi-check
                        v-icon(v-else color="red lighten-1") mdi-close
                      td.text-start {{ item.pct }}%

</template>

<script>
  export default {
    name: "CategoryInfoDialog",
    props:{
      data:{
        type: Object,
        default: function(){
          return {}
        }
      }
    },
    data:() => ({
      dialog: false,
    }),
    computed: {
      translations() {
        return this.$t("components.categoryInfoCard");
      },
      headers(){
        return[
          {
            text: this.translations.name,
            value: 'name'
          },
          {
            text: this.translations.level,
            value: 'level'
          },
          {
            text: this.translations.points,
            value: 'points'
          },
          {
            text: this.translations.rollDown,
            value: 'rollDown'
          },
          {
            text: this.translations.percentage,
            value: 'percentage'
          },
        ]
      },
    }
  }
</script>

<style lang="sass">
</style>